import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { loadavg } from 'os';
import { ICourse } from '../../store/interface'
import { NavLink as RouterNavLink } from 'react-router-dom';
import { Row, Col, Card, CardImg, CardTitle, CardText, CardGroup,
    CardSubtitle, CardBody, Spinner, ListGroup, ListGroupItem, Button, 
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import { Redirect } from 'react-router-dom';

interface IState {
    modal: boolean
    childTerm : string
    searchSorting : string
    searchSortingDisplay : string
    searchSortingDropDownOpen : boolean
    redirect: boolean
    redirectCourseId: string
}
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    term:string
    sorting:string
    profession:string
    totalDocument : number
    offset : number
    limit : number
    data: any[]
    loading: boolean
    firstLoad: boolean
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    onLoadMore: any
    onSorting:any
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch;


class SearchResult extends React.Component<AllProps, IState> {

    /**
     *
     */
    constructor(props: AllProps) {
        super(props);
        this.state = {
            modal: false,
            childTerm : this.props.term,
            searchSortingDisplay: 'Title',
            searchSorting: this.props.sorting,
            searchSortingDropDownOpen: false,
            redirect: false,
            redirectCourseId : ""
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.onChangeSorting = this.onChangeSorting.bind(this);
        //this.test = this.test.bind(this);
    }
    public componentDidMount() {
        
    }
    componentDidUpdate(prevProps: AllProps) {
        if (prevProps.sorting != this.props.sorting){
            // if (this.props.sorting == ""){
            //     this.setState({ searchSortingDisplay: "Title" });
            // }
            this.setState({ searchSortingDisplay: this.SortExpressionDisplay(this.props.sorting) });
        }
    }

    onInputChange(e:any) {
        this.setState({ childTerm: e.target.value });
    }

    SortExpressionDisplay(sortExpression:string){
        var display = "";
        if (!sortExpression) sortExpression = "Title";
        switch(sortExpression.toLowerCase()) {
            case "c.titleLowercase":
                display  = "Title";
                break;
            case "c.publisheddt desc":
                display  = "Newest";
                break;
            // case "c.cpdpoints":
            //     display  = "Lowest CPD Point";
            //     break;
            // case "c.cpdpoints desc":
            //     display  = "Highest CPD Point";
            //     break;
            case "c.duration":
                display  = "Shortest Video";
                break;
            case "c.duration desc":
                display  = "Longest Video";
                break;
            case "c.organiser.name":
                display  = "Organiser";
                break;
            case "c.normalprice":
                display  = "Lowest Price";
                break;
            case "c.normalprice desc":
                display  = "Highest Price";
                break;
            default:
                display = "Title" ;
        }
        return display;
    }

    onChangeSorting(e:any){
        var sortText = e.currentTarget.textContent;
        var sortExpression = "";
        switch(sortText) {
            case "Title":
                sortExpression  = "c.titleLowercase";
                break;
            case "Newest":
                sortExpression  = "c.publishedDT DESC";
                break;
            // case "Lowest CPD Point":
            //     sortExpression  = "c.cpdPoints";
            //     break;
            // case "Highest CPD Point":
            //     sortExpression  = "c.cpdPoints DESC";
            //     break;
            case "Shortest Video":
                sortExpression  = "c.duration";
                break;
            case "Longest Video":
                sortExpression  = "c.duration DESC";
                break;
            case "Organiser":
                sortExpression  = "c.organiser.name";
                break;
            case "Lowest Price":
                sortExpression  = "c.normalPrice";
                break;
            case "Highest Price":
                sortExpression  = "c.normalPrice DESC";
                break;
            default:
                sortExpression  = "c.titleLowercase";
          }

        this.setState({ searchSortingDisplay : sortText, searchSorting: sortExpression}, () => {
            this.props.onSorting(this.state);
        }
    )
    }

    SecondsTohhmmss(totalSeconds:number) {
        var hours   = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
        var seconds = totalSeconds - (hours * 3600) - (minutes * 60);
      
        // round seconds
        seconds = Math.round(seconds * 100) / 100
      
        var result = (hours < 10 ? "0" + hours : hours);
            result += ":" + (minutes < 10 ? "0" + minutes : minutes);
            result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
        return result;
    }

    onRowSelected(courseId:string, e:any){
        //console.log("Course ID:" +courseId);
        this.setState({redirect : true, redirectCourseId: courseId}, () => {
        });
    }

    constructCPDPoint(array: any) {
        let data: any = [];

        array.forEach((element: any) => {
            //data.push(element.profession + " (" + element.points + ")");
            if (element.cpdDesc)
                data.push(element.profession + " (" + element.cpdDesc + ")");
            else
                data.push(element.profession + " (" + element.cpdRefNo + ")");
            // data.push("Engineer: 123");
        });

        return  {__html:data.join("<br/>")};
    }
    
    expiredReminder(date: Date) {
        const expiryDate = new Date(date);
        const today = new Date();
        const diffTime:number = Math.abs(expiryDate.getTime() - today.getTime()); 
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        if (diffDays < 30){
            return <Badge color="danger">Hurry up! Video will be de-listed in {diffDays} day(s). Subscribe while it still available!</Badge>;
            //return <Badge color="danger">Hurry up! Only {diffDays} day(s) remains</Badge>;
        }
    }
    
    FormatDate(date: Date) {
        var displayDate = new Date(date);
        var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' } as const;
        return displayDate.toLocaleDateString("en-US", options);
    }

    GetImagePath(fileName: string){
        fileName = fileName.replace("/courses/","").replace(".jpg","_xs.jpg");
        return "https://images.ultimatespro.com/images/" + fileName;
    }
    
    public render() {   
        const tdStyle = {
             padding : "15px"
          };

        const showLoadMore = (this.props.offset + this.props.limit) < this.props.totalDocument;
        const toggleSortingDropDown = () => this.setState({searchSortingDropDownOpen : !this.state.searchSortingDropDownOpen}); 

        if (this.state.redirect){
            return (
                <Redirect push to={{
                    pathname: '/courses/' + this.state.redirectCourseId
                }} />
                // <Redirect to={"/courses/" + this.state.redirectCourseId } />
            )
        }
        else{
            return (
                <div onScroll={this.props.onLoadMore.bind(this, this.state)}>
                    {/* <h3>{this.props.term} - {this.props.profession} - {this.props.totalDoc} search result(s)</h3> */}
                    
                    <ListGroup>
                        <ListGroupItem>
                            <Row>
                                <Col lg="9" >
                                    <h5>{this.props.totalDocument} result(s) ({this.props.profession == ""? "All Profession": this.props.profession})</h5>
                                </Col>
                                <Col lg="3" >
                                    <Dropdown isOpen={this.state.searchSortingDropDownOpen} toggle={toggleSortingDropDown}>
                                        <DropdownToggle caret color="secondary" block>
                                            <i className="fas fa-sort mr-1"></i>
                                            {this.state.searchSortingDisplay}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem header>Sort</DropdownItem>
                                            <DropdownItem divider/>
                                            <DropdownItem onClick={this.onChangeSorting}>Title</DropdownItem>
                                            {/* <DropdownItem onClick={this.onChangeSorting}>Lowest CPD Point</DropdownItem>
                                            <DropdownItem onClick={this.onChangeSorting}>Highest CPD Point</DropdownItem> */}
                                            <DropdownItem onClick={this.onChangeSorting}>Shortest Video</DropdownItem>
                                            <DropdownItem onClick={this.onChangeSorting}>Longest Video</DropdownItem>
                                            <DropdownItem onClick={this.onChangeSorting}>Organiser</DropdownItem>
                                            <DropdownItem onClick={this.onChangeSorting}>Newest</DropdownItem>
                                            <DropdownItem onClick={this.onChangeSorting}>Lowest Price</DropdownItem>
                                            <DropdownItem onClick={this.onChangeSorting}>Highest Price</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </ListGroupItem>
                    {
                        this.props.data.map(item =>(
                            <ListGroupItem key={item.id}>
                                {/* <Row onClick={this.onRowSelected.bind(this, item.courseId)}> */}
                                <Row>
                                    <Col lg="3" style={{cursor: "pointer", display: "flex", alignItems: "center"}} >
                                        <img src={this.GetImagePath(item.videoThumbnailURL)} width="250px" onClick={this.onRowSelected.bind(this, item.courseId)} />
                                    </Col>
                                    <Col lg="6">
                                        {/* <h4>{item.courseId}</h4> */}
                                        <h5 style={{cursor: "pointer"}}>{item.title}</h5>                                        
                                        Organise by <span style={{fontWeight:"bold"}}>{(item.organiser.orgName) ? item.organiser.orgName : item.organiser.name}</span> 
                                        <br/>
                                        {/* {this.expiredReminder(item.expiryDT)}  */}
                                        <br/>Profession : {item.professionList.join(", ")}
                                        <br/>Language : {item.languages.join(", ")}
                                        <br/>Subtitle : {item.subtitle ? item.subtitle.length ==0? "N/A" : item.subtitle.join(", ") : "N/A"}
                                        <br/>Published on : {this.FormatDate(item.publishedDT)}
                                        <br/>Delisted on : {this.FormatDate(item.expiryDT)} {this.expiredReminder(item.expiryDT)}
                                    </Col>
                                    <Col lg="3">
                                        <h3>{item.currency == null ? "RM" : item.currency} {item.normalPrice}</h3>
                                        <span style={{fontSize:"smaller", fontWeight:"bold"}}>Credit Hours/Points: </span><br/>
                                        <div style={{fontSize:"smaller"}} dangerouslySetInnerHTML={this.constructCPDPoint(item.cpdPoints)} /><br/>
                                        Duration : {this.SecondsTohhmmss(item.duration)}<br/>
                                        <RouterNavLink to={"/courses/" + item.courseId}><Button color="primary" block>Read More</Button></RouterNavLink>
                                    </Col>
                                </Row>
                            </ListGroupItem>
                        ))
                        }
    
                        <ListGroupItem key="loadmore">
                            <Row>
                                <Col lg="12">
                                    <Spinner color="warning" hidden={!this.props.loading} />
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12">
                                    <Button color="secondary" 
                                        onClick={this.props.onLoadMore.bind(this, this.state)} block
                                        hidden={!showLoadMore} >
                                        Load More
                                    </Button>
                                </Col>
                            </Row>
                        </ListGroupItem>
                    </ListGroup>
                </div>
            )
        }
    }
    // toggleClose() {
    //     this.setState({
    //         modal: false
    //     })
    // }
    // toggleOpen() {
    //     this.setState({
    //         modal: true
    //     })
    // }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps
)(SearchResult)